<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title"><a id="page_3"></a>A TIME OF<br/>CHANGES</h1>
<p class="image"><img alt="Image" src="images/flower.jpg"/></p>
<p class="author">ROBERT<br/>SILVERBERG</p>
<p class="para"> </p>
<p class="linespace"> </p>
<p class="editor"><img alt="Image" src="images/pub.jpg"/><br/><br/>A TOM DOHERTY ASSOCIATES BOOK<br/>NEW YORK</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?4914334f